import { Link, useNavigate } from "react-router-dom";
import icons from "../../../../../Data/icons";
import man from "../../../../../assets/images/dashboard/1.png";
import { Col, Row } from "react-bootstrap";
import { Issues, Resolved, Comment, Done } from "../../../../../Constant";
import { Progress } from "reactstrap";
import { useState } from "react";

const SingleTask = ({ task, classes }) => {
  const [showTooltip, setShowTooltip] =useState(false)
  const {
    id,
    status, 
    progress,
    name,
    publisher,
    lists_count,notes_count,
    employes
  } = task;
  const percentage = Math.min(Math.max(progress, 0), 100);
  const navigate = useNavigate();
  const EyeIcon = icons.eye;
  const EditIcon = icons.pen;
  const DeleteIcon = icons.trash;


  return (
    <div className="col-xxl-4" lg="6">
      <div className="project-box bg-white">
      <Link to={`${process.env.PUBLIC_URL}/tasks/${id}`}> <h6 className="mb-2">{name}</h6>  </Link> 
  
        <span
          className={`badge ${
            status === "completed" ? "badge-success" :  status === "expired"? "badge-danger" :status === "pending" ? "badge-info" :status ==="started" ?"badge-primary" :"badge-warning"
          }`}>
          {status} 
        </span>

        <div className="media">
          <div className="media-body">
            <p>{publisher}</p>
          </div>
        </div>

        <Row className=" details">
          <Col className="col-6">
            <span>المهام</span>
          </Col>
          <Col xs="6" className="font-primary">{lists_count}</Col>
          <Col xs="6" className="font-primary">
            <span>الملاحظات</span>
          </Col>
          <Col xs="6" className="font-primary">{notes_count}</Col>
        
        </Row>
        <div className="customers">
          <ul>
          {employes.map((employe)=>(
            <li  className="d-inline-block tool-tip"  key={employe.id} onMouseEnter={()=>setShowTooltip(true)} onMouseLeave={()=>setShowTooltip(false)}>
              {showTooltip &&<span className="showtool-tip">{employe.name_ar}</span>}
              <img className="img-30 rounded-circle" src={employe.image} alt="" />
            </li>  
          ))  }
            
            <li className="d-inline-block ms-2">
              <p className="f-12"></p>
            </li>
          </ul>
        </div>
        <div className="project-status mt-4">
          <div className="media mb-0">
            <p>{percentage}% </p>
            <div className="media-body text-end">
              <span>{Done}</span>
            </div>
          </div>
          {progress === "100" ? (
            <Progress
              className="sm-progress-bar"
              striped
              value={progress}
              color="secondary"
              style={{ height: "20px" }}
            />
          ) : (
            <Progress
              className="sm-progress-bar"
              
              value={progress}
              color="success"
              style={{ height: "20px" }}
            />
          )}
      
        </div>
      </div>
    </div>
   
  );
};

export default SingleTask;
